import { render, staticRenderFns } from "./WaybillCreateRXReal.vue?vue&type=template&id=1dc0f238&scoped=true&"
import script from "./WaybillCreateRXReal.vue?vue&type=script&lang=js&"
export * from "./WaybillCreateRXReal.vue?vue&type=script&lang=js&"
import style0 from "./WaybillCreateRXReal.vue?vue&type=style&index=0&id=1dc0f238&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc0f238",
  null
  
)

export default component.exports